import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Wordmark, Sparkle } from "../components/BrandLogo";
import { Button } from "../components/ui/button";
import { useAuth } from "../contexts/AuthContext";

export default function Welcome() {
  const navigate = useNavigate();
  const { profile } = useAuth();
  const { t } = useTranslation();
  React.useEffect(() => {
    // Forward to Today if either the server-side profile or the local
    // "onboarded" flag says we're past onboarding. The local flag is the
    // safety net for cold reloads on iOS Capacitor where /me may still be
    // in flight on mount.
    let localFlag = false;
    try { localFlag = window.localStorage.getItem("ss_onboarded") === "1"; }
    catch { /* ignore */ }
    if (profile?.onboarded || localFlag) {
      navigate("/today", { replace: true });
    }
  }, [profile, navigate]);

  return (
    <div className="ss-soft-bg min-h-[100dvh] w-full">
      <div className="relative mx-auto w-full max-w-md min-h-[100dvh] px-8 py-10 flex flex-col">
        <div className="absolute top-8 right-8">
          <Sparkle className="w-4 h-4 text-brand/70" />
        </div>

        <div className="pt-10 animate-fade-up">
          <Wordmark />
          <p className="mt-4 text-sm tracking-[0.2em] uppercase text-foreground/60">
            {t("welcome.tagline")}
          </p>
        </div>

        <div className="mt-14 animate-fade-up" style={{ animationDelay: "120ms" }}>
          <h1 className="font-serif text-4xl sm:text-5xl leading-[1.05] text-foreground">
            {t("welcome.headline_a")}
            <em className="text-brand">{t("welcome.headline_em")}</em>
            {t("welcome.headline_b")}
          </h1>
          <p className="mt-6 text-foreground/75 leading-relaxed">
            {t("welcome.sub")}
          </p>
        </div>

        <div className="mt-auto pt-12 space-y-3 animate-fade-up" style={{ animationDelay: "240ms" }}>
          <Button
            data-testid="welcome-begin-btn"
            onClick={() => navigate("/onboarding")}
            className="w-full h-14 rounded-full bg-brand hover:bg-brand/90 text-white text-base font-medium shadow-md"
          >
            {t("welcome.begin")}
          </Button>

          <button
            data-testid="welcome-signin-link"
            onClick={() => navigate("/auth")}
            className="w-full text-sm text-foreground/60 hover:text-brand transition-colors py-2"
          >
            {t("welcome.have_account")}
          </button>
          <p className="text-center text-xs text-foreground/50 pt-2">
            {t("welcome.no_account_note")}
          </p>
        </div>
      </div>
    </div>
  );
}
